export const SET_CONTEXT_MENU_VISIBILITY = "SET_CONTEXT_MENU_VISIBILITY";
export const SET_SELECTED_ITEM_ID = "SET_SELECTED_ITEM_ID";
export const UPDATE_SELECTED_ITEMS = "UPDATE_SELECTED_ITEMS";
export const CLEAR_SELECTED_ITEMS = "CLEAR_SELECTED_ITEMS";
export const SET_MULTIPLE_SELECTION = "SET_MULTIPLE_SELECTION";

interface ContextMenuCoordinates {
  top: number;
  left: number;
}

export interface ContextMenu {
  visibility: boolean;
  coordinates: ContextMenuCoordinates;
  selectedItemId: string;
  selectedItemsId: string[];
  clipboard: string;
  isMultipleSelection: boolean;
}

type ContextMenuAction = typeof SET_CONTEXT_MENU_VISIBILITY | typeof SET_SELECTED_ITEM_ID | typeof UPDATE_SELECTED_ITEMS | typeof CLEAR_SELECTED_ITEMS | typeof SET_MULTIPLE_SELECTION;

export interface ContextMenuPayload {
  type: ContextMenuAction;
  data: any;
}
